// extracted by mini-css-extract-plugin
export default {"wrapper_three":"ThreeColorDivider_wrapper_three__8X2bf","wrapper_one":"ThreeColorDivider_wrapper_one__RDzzM"};